import { fromJS } from 'immutable';
import { abortableFetch, getArcadeFetchOptions } from '@americanexpress/arcade-core';
import { addErrorToReport } from '@americanexpress/one-app-ducks';
import { STAMPS_SCAN_STATUS } from './constants';

export const apiGetUserStatus = () => async (dispatch, getState) => {
  const options = {
    url: `${getState().getIn(['config', 'arcadeApiUrl'])}/v1/passport/profile/status`,
    init: getArcadeFetchOptions(),
  };

  dispatch({
    type: 'modules/arcade-root/SET_PROFILE_STATUS_LOADING',
    payload: true,
  });

  abortableFetch({
    options,
    onResponse: (status, data) => {
      let action = {
        type: 'modules/arcade-root/SET_PROFILE_STATUS_API_ERROR',
        payload: true,
      };
      if (data && (status === 200 || status === 401 || status === 404)) {
        action = {
          type: 'modules/arcade-root/MERGE_VALUES',
          payload: fromJS({
            userStatus: data.status_code,
            canProfileRefresh: data.profile_refresh_indicator,
            isEnrollmentCapMet: data.is_enroll_cap_met,
            isProfileStatusApiError: false,
            isProfileStatusLoading: false,
          }),
        };
      }
      dispatch(action);
    },
    onException: (e, timestamp) => {
      dispatch({
        type: 'modules/arcade-root/SET_PROFILE_STATUS_API_ERROR',
        payload: true,
      });
      dispatch(addErrorToReport(e, {
        collectionMethod: 'apiGetUserStatus - Exception',
        moduleID: 'arcade-page-wrapper',
        trackingId: options.init.headers['x-amex-tracking-id'],
        ...timestamp,
      }));
    },
    dispatch,
  });
};

export const apiProfileRefresh = () => async (dispatch, getState) => {
  const options = {
    url: `${getState().getIn(['config', 'arcadeApiUrl'])}/v1/passport/profile`,
    init: {
      ...getArcadeFetchOptions(),
      method: 'PUT',
      body: JSON.stringify({ operation: 'update' }),
    },
  };

  await abortableFetch({
    options,
    onResponse: (status, data) => data && status === 200,
    onException: (e, timestamp) => {
      dispatch(addErrorToReport(e, {
        collectionMethod: 'apiProfileRefresh - Exception',
        moduleID: 'arcade-page-wrapper',
        trackingId: options.init.headers['x-amex-tracking-id'],
        ...timestamp,
      }));
    },
    dispatch,
  });
  dispatch({ type: 'modules/arcade-root/SET_PROFILE_REFRESH', payload: false });
};

export const apiSurveyPromptStatus = (setSurveyPromptStatus) => async (dispatch, getState) => {
  const options = {
    url: `${getState().getIn(['config', 'arcadeApiUrl'])}/v1/passport/feedback/prompt/status`,
    init: getArcadeFetchOptions(),
  };
  return abortableFetch({
    options,
    onResponse: (_, data) => {
      setSurveyPromptStatus(data.feedback_prompt_status);
    },
    onException: (e, timestamp) => {
      dispatch(addErrorToReport(e, {
        collectionMethod: 'apiSurveyPromptStatus - Exception',
        moduleID: 'arcade-page-wrapper',
        trackingId: options.init.headers['x-amex-tracking-id'],
        ...timestamp,
      }));
    },
    dispatch,
  });
};

export const apiSubmitSurveyPrompt = () => async (dispatch, getState) => {
  const options = {
    url: `${getState().getIn(['config', 'arcadeApiUrl'])}/v1/passport/feedback`,
    init: {
      ...getArcadeFetchOptions(),
      method: 'POST',
      body: JSON.stringify({ is_feedback_prompted: true }),
    },
  };

  const maxAttempts = 3;
  let responseData;

  for (let i = 0; i < maxAttempts; i += 1) {
    // eslint-disable-next-line no-await-in-loop -- need to retry on failure
    responseData = await abortableFetch({
      options,
      onResponse: (_, data) => (data.status_code === 'success' ? data : null),
      onException: (e, timestamp) => {
        dispatch(addErrorToReport(e, {
          collectionMethod: 'apiSubmitSurveyPrompt - Exception',
          moduleID: 'arcade-page-wrapper',
          trackingId: options.init.headers['x-amex-tracking-id'],
          ...timestamp,
        }));
        return null;
      },
      dispatch,
    });

    if (responseData) {
      break;
    }
  }

  if (!responseData) {
    dispatch(addErrorToReport(new Error('Max attempts reached.'), {
      collectionMethod: 'apiSubmitSurveyPrompt - Exception',
      moduleID: 'arcade-page-wrapper',
      trackingId: options.init.headers['x-amex-tracking-id'],
    }));
  }
};

let intervalId;
let statusCallCount = 0;
const resetInterval = () => {
  clearInterval(intervalId);
  intervalId = null;
  statusCallCount = 0;
};

export const apiPollStampsScanStatus = () => (dispatch, getState) => {
  if (!intervalId) {
    intervalId = setInterval(async () => {
      const options = {
        url: `${getState().getIn(['config', 'arcadeApiUrl'])}/v1/passport/profile/scan/status`,
        init: getArcadeFetchOptions(),
      };
      if (statusCallCount < 8) {
        statusCallCount += 1;
        abortableFetch({
          options,
          onResponse: (status, data) => {
            if (data.status_code === STAMPS_SCAN_STATUS.COMPLETED) {
              resetInterval();
              dispatch({
                type: 'modules/arcade-root/MERGE_VALUES',
                payload: fromJS({
                  stampsScanStatus: data.status_code,
                  showScanBanner: true,
                }),
              });
            }
          },
          onException: (e) => {
            console.log(e, 'ignore error and retry');
          },
          dispatch,
        });
      } else {
        resetInterval();
        dispatch({
          type: 'modules/arcade-root/MERGE_VALUES',
          payload: fromJS({
            stampsScanStatus: STAMPS_SCAN_STATUS.ERROR,
            showScanBanner: true,
          }),
        });
        dispatch(addErrorToReport(new Error('Fins scan timeout'), {
          collectionMethod: 'apiPollStampsScanStatus - Max Retries',
          moduleID: 'arcade-page-wrapper',
          trackingId: options.init.headers['x-amex-tracking-id'],
        }));
      }
    }, 10000);
  }
};
